import { render, staticRenderFns } from "./updateProfileReview.vue?vue&type=template&id=7f4760a0&"
import script from "./updateProfileReview.vue?vue&type=script&lang=js&"
export * from "./updateProfileReview.vue?vue&type=script&lang=js&"
import style0 from "./updateProfileReview.vue?vue&type=style&index=0&id=7f4760a0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports